import { useState } from 'react';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';
import { priceHistory24h, priceHistory30d } from '@/mocks/goldPrices';

type Range = '24h' | '30d';

const ranges: { key: Range; label: string }[] = [
  { key: '24h', label: '24 giờ' },
  { key: '30d', label: '30 ngày' },
];

export default function PriceChart() {
  const [range, setRange] = useState<Range>('30d');
  const data = range === '24h' ? priceHistory24h : priceHistory30d;
  const xKey = range === '24h' ? 'time' : 'date';

  return (
    <div className="rounded-xl border border-background-200/60 p-4 md:p-5">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-4">
        <div>
          <h3 className="text-sm font-semibold text-foreground-950">Biểu đồ giá vàng SJC</h3>
          <p className="text-xs text-foreground-600">Đơn vị: VNĐ / lượng</p>
        </div>
        <div className="inline-flex rounded-full border border-background-300/60 p-1 bg-background-100">
          {ranges.map((r) => (
            <button
              key={r.key}
              onClick={() => setRange(r.key)}
              className={`px-4 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap cursor-pointer transition-colors ${
                range === r.key ? 'bg-primary-500 text-background-950' : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              {r.label}
            </button>
          ))}
        </div>
      </div>

      <div className="h-64 md:h-72">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="goldGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="oklch(var(--primary-500))" stopOpacity={0.45} />
                <stop offset="95%" stopColor="oklch(var(--primary-500))" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="oklch(var(--background-300) / 0.5)" vertical={false} />
            <XAxis
              dataKey={xKey}
              tick={{ fill: 'oklch(var(--foreground-600))', fontSize: 11 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={{ fill: 'oklch(var(--foreground-600))', fontSize: 11 }}
              axisLine={false}
              tickLine={false}
              tickFormatter={(v: number) => `${(v / 1000000).toFixed(1)}tr`}
              width={52}
            />
            <Tooltip
              contentStyle={{
                background: 'oklch(var(--background-100))',
                border: '1px solid oklch(var(--background-300))',
                borderRadius: 8,
                color: 'oklch(var(--foreground-950))',
              }}
              formatter={(value: number | string) => [Number(value).toLocaleString('vi-VN') + 'đ', 'Giá']}
            />
            <Area
              type="monotone"
              dataKey="price"
              stroke="oklch(var(--primary-500))"
              strokeWidth={2}
              fill="url(#goldGradient)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}